import { Avatar, Box, makeStyles, Typography } from "@material-ui/core";

import type { CoretexTheme } from "../theme";

export interface MapUserIconProps {
  initials: string;
  pulse?: boolean;
}

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    position: "relative",
    width: 42,
    height: 42,
  },
  avatar: {
    width: 32,
    height: 32,
    backgroundColor: theme.palette.mono.ultraDark,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  wrapper: {
    width: 35,
    height: 35,
    backgroundColor: "transparent",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "50%",
    animation: "$pulse 1.5s infinite",
  },
  text: {
    fontWeight: 700,
    fontSize: 14,
    color: theme.palette.mono.white,
    textTransform: "uppercase",
  },
  "@keyframes pulse": {
    "0%": {
      boxShadow: "0px 0px 0px 0px rgba(4, 12, 53, 0.1)",
    },
    "100%": {
      boxShadow: "0px 0px 0px 20px rgba(4, 12, 53, 0)",
    },
  },
}));

const MapUserIcon = ({ initials, pulse }: MapUserIconProps): JSX.Element => {
  const classes = useStyles();
  const sanitisedInitials = initials.substr(0, 2);
  return (
    <Box className={classes.root}>
      <Avatar className={classes.avatar}>
        <Typography className={classes.text}>{sanitisedInitials}</Typography>
      </Avatar>
      {pulse && <Box className={classes.wrapper} />}
    </Box>
  );
};

export default MapUserIcon;
